import { auth } from "./firebase";

// fetch() wrapper that attaches the signed-in user's Firebase ID token as
// "Authorization: Bearer <token>" — the backend verifies this on every
// protected route instead of trusting a client-supplied userId.
export async function authFetch(url, options = {}) {
  const user = auth.currentUser;
  if (!user) throw new Error("Not signed in");
  const token = await user.getIdToken();
  const headers = { ...(options.headers || {}), Authorization: `Bearer ${token}` };
  return fetch(url, { ...options, headers });
}
